<ng-template #content>
  <ng-content></ng-content>
</ng-template>

<button
  type="button"
  fuButton
  [size]="size()"
  [uiType]="uiType()"
  [disabled]="disabled()"
  [isPressed]="isPressed()"
  [onlyIcon]="onlyIcon()"
  (click)="onClick($event)"
  [class.full-width]="fullWidth()"
  [class.icon-left]="iconPosition() === 'left'"
>
  @switch (uiType()) {
    @case ("custom") {
      <ng-container *ngTemplateOutlet="content" />
    }
    @case ("quaternary") {
      <ng-container *ngTemplateOutlet="content" />
      <fu-icon
        [iconName]="iconName() || 'right-arrow'"
        [size]="size() === 's' ? 18 : 24"
      />
    }
    @default {
      <ng-container *ngTemplateOutlet="content" />

      @if (iconName()) {
        <fu-icon [iconName]="iconName()" [size]="size() === 's' ? 20 : 24" />
      }
    }
  }
</button>
